import {useState} from "../../../__snowpack__/pkg/react.js";
import queryString from "../../../__snowpack__/pkg/query-string.js";
import {axios} from "../../lib/axios.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {handleError} from "../../lib/errorHandler.js";
export const useProductList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (pageInfo, search) => {
    setLoading(true);
    try {
      let params = {
        channelId: search?.channelId,
        status: search?.status,
        keyword: search?.keyword,
        keywordType: search?.keywordType,
        mpType: search?.mpType,
        stockStatus: search?.stockStatus,
        sortType: search?.sortType,
        categories: search?.categories,
        type: search?.type,
        shopIds: search?.shopIds,
        countryCode: search?.countryCode,
        inventorySku: search?.inventorySku?.value,
        updateDates: search?.updateDates,
        hasChildrenCategory: search?.hasChildrenCategory || false,
        warehouseIds: search?.warehouseIds || []
      };
      const {
        data: {content, number: page, size: pageSize, totalElements: pageTotal}
      } = await axios.post(`/saas/product/v1/products/search?${queryString.stringify({
        page: pageInfo && pageInfo.page && pageInfo.page - 1,
        size: pageInfo && pageInfo.pageSize
      })}`, params);
      setData(content);
      return {
        productList: content,
        productListPageInfo: {
          page: page + 1,
          pageSize,
          pageTotal
        }
      };
    } catch (error) {
      handleError(error);
      return {
        productList: data,
        productListPageInfo: pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productListLoading: loading,
    productList: data,
    fetchProductList: fetchData
  };
};
export const useProductListModel = createModel(useProductList);
export const useProductSearchBriefs = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [briefsPageInfo, setBriefsPageInfo] = useState({
    page: 1,
    pageSize: 50,
    pageTotal: 0
  });
  const fetchData = async (pageInfo, search) => {
    setLoading(true);
    try {
      let params = {
        channelId: search?.channelId,
        status: search?.status,
        keyword: search?.keyword,
        keywordType: search?.keywordType,
        mpType: search?.mpType,
        stockStatus: search?.stockStatus,
        sortType: search?.sortType,
        categories: search?.categories,
        type: search?.type,
        shopIds: search?.shopIds,
        countryCode: search?.countryCode,
        inventorySku: search?.inventorySku?.value,
        updateDates: search?.updateDates,
        hasChildrenCategory: search?.hasChildrenCategory || false,
        warehouseIds: search?.warehouseIds || []
      };
      const {
        data: {content, number: page, size: pageSize, totalElements: pageTotal}
      } = await axios.post(`/saas/product/v1/products/search-briefs?${queryString.stringify({
        page: pageInfo && pageInfo.page && pageInfo.page - 1,
        size: pageInfo && pageInfo.pageSize
      })}`, params);
      setData(content);
      setBriefsPageInfo({
        page: page + 1,
        pageSize,
        pageTotal
      });
      return {
        productList: content,
        productListPageInfo: briefsPageInfo
      };
    } catch (error) {
      handleError(error);
      return {
        productList: data,
        productListPageInfo: pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productListLoading: loading,
    productList: data,
    fetchProductList: fetchData,
    briefsPageInfo
  };
};
export const useProductSearchBriefsModel = createModel(useProductSearchBriefs);
